import { render } from "./index.vue?vue&type=template&id=11afd1af&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=11afd1af&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11afd1af"],['__file',"src/views/jbh/achievementManage/tagScore/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11afd1af"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11afd1af', __exports__)) {
    console.log('reload')
    api.reload('11afd1af', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=11afd1af&scoped=true", () => {
    console.log('re-render')
    api.rerender('11afd1af', render)
  })

}


export default __exports__